/**
 * Dev-only browser tab identity: `locl | Canvas | My store` on local and staging hosts.
 * Production hosts return `null` and keep the brand title and favicon untouched.
 */

export type DevEnvLabel = 'locl' | 'stag';

const LOCAL_HOST = /^(localhost|127\.0\.0\.1|.+\.localhost)$/;
const STAGING_HOST = /\.(tagada\.dev|tagadapay\.dev|vercel\.app)$/;

export function devEnvLabel(hostname: string): DevEnvLabel | null {
  if (LOCAL_HOST.test(hostname)) {
    return 'locl';
  }
  if (STAGING_HOST.test(hostname)) {
    return 'stag';
  }
  return null;
}

const humanize = (segment: string): string => {
  const words = segment.replace(/[-_]+/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** Meaningful segments of the path: drops `/org/:slug`, `stores/:storeId` and `settings`. */
const screenSegments = (pathname: string): readonly string[] => {
  const segments = pathname.split('/').filter((segment) => segment.length > 0);
  const inOrg = segments[0] === 'org' ? segments.slice(2) : segments;
  const inStore = inOrg[0] === 'stores' && inOrg.length > 2 ? inOrg.slice(2) : inOrg;
  return inStore[0] === 'settings' && inStore.length > 1 ? inStore.slice(1) : inStore;
};

export function screenLabel(pathname: string): string {
  const first = screenSegments(pathname)[0];
  return first === undefined ? 'Home' : humanize(first);
}

export function devTabTitle(env: DevEnvLabel, screen: string, storeName: string | null): string {
  return [env, screen, storeName]
    .filter((part): part is string => part !== null && part.length > 0)
    .join(' | ');
}
